import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getQuery } from '@src/utils/index';

const Feed = ({ content }) => {
    const date = getQuery(window.location.href, 'date') || '';
    const aLink = content?.link?.weburl.includes('?') ? `${content?.link?.weburl}&ref=aibrief_${date}` : `${content?.link?.weburl}?ref=aibrief_${date}`;

    return (
        <a href={aLink} className={styles.feed}>
            {content?.title && <div className={styles.feedTitle}>{content.title || ''}</div>}
            {content?.intro && <div className={styles.feedBref}>{content?.intro}</div>}
            {content?.imageList?.[0]?.url && <img src={content.imageList[0].url} className={styles.feedImg} />}
        </a>
    );
};

Feed.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Feed);
